// eslint-disable-next-line no-unused-vars
import React from "react"
/** @jsx jsx */
import { jsx } from "theme-ui"

import { colors } from "../../utils/theme/colors"
import { fontWeights } from "../../utils/theme/font-weights"
import { FaStar } from "react-icons/fa"

const SuccessClientSection4 = ({
  title,
  paragraph1,
  paragraph2,
  paragraph2span,
  paragraph3,
  paragraph3span,
  paragraph3second,
}) => {
  return (
    <div
      sx={{
        display: `flex`,
        flexDirection: `column`,
        marginTop: `1.6rem`,
      }}
    >
      <p
        sx={{
          color: colors.code.secondary,
          fontSize: `1.375rem`,
          fontWeight: fontWeights.black,
        }}
      >
        {title}
      </p>
      <div sx={{ display: `flex` }}>
        <FaStar
          sx={{
            color: colors.code.primary,
            marginRight: `1rem`,
            marginTop: `5px`,
          }}
        />
        <p
          sx={{
            color: colors.code.secondary,
            fontSize: `0.938rem`,
            fontWeight: fontWeights.bold,
            width: `80%`,
          }}
        >
          {paragraph1}
        </p>
      </div>
      <div sx={{ display: `flex` }}>
        <FaStar
          sx={{
            color: colors.code.primary,
            marginRight: `1rem`,
          }}
        />
        <p
          sx={{
            color: colors.code.secondary,
            fontSize: `0.938rem`,
            fontWeight: fontWeights.bold,
            width: `80%`,
          }}
        >
          <span sx={{ color: colors.code.primary }}> {paragraph2span} </span>
          {paragraph2}
        </p>
      </div>
      <div sx={{ display: `flex` }}>
        <FaStar
          sx={{
            color: colors.code.primary,
            marginRight: `1rem`,
          }}
        />
        <p
          sx={{
            color: colors.code.secondary,
            fontSize: `0.938rem`,
            fontWeight: fontWeights.bold,
            width: `80%`,
          }}
        >
          {paragraph3}
          <span sx={{ color: colors.code.primary }}> {paragraph3span} </span>
          {paragraph3second}
        </p>
      </div>
    </div>
  )
}

export default SuccessClientSection4
